<template>
  <ul class="f-social-media-links no-markers">
    <li>
      <a href="https://www.discord.gg/AwFAqUHkqD" target="_blank" rel="nofollow" title="Corex on Discord">
        <icon data="@/assets/svg/social-media/discord.svg" width="24" height="24"></icon>
      </a>
    </li>
    <li>
      <a href="https://www.twitter.com/COREXmn" target="_blank" rel="nofollow" title="Corex on Twitter">
        <icon data="@/assets/svg/social-media/twitter.svg" width="24" height="24"></icon>
      </a>
    </li>
    <li>
      <a href="https://www.instagram.com/corex.mn/" target="_blank" rel="nofollow" title="Corex on Instagram">
        <icon data="@/assets/svg/social-media/instagram.svg" width="24" height="24"></icon>
      </a>
    </li>
    <li>
      <a href="https://www.facebook.com/COREXblockchain" target="_blank" rel="nofollow" title="Corex on Facebook">
        <icon data="@/assets/svg/social-media/facebook.svg" width="24" height="24"></icon>
      </a>
    </li>
    <li>
      <a href="https://github.com/corex-mn" target="_blank" rel="nofollow" title="Corex on Github">
        <icon data="@/assets/svg/social-media/github.svg" width="24" height="24"></icon>
      </a>
    </li>
    <!--    <li>-->
    <!--      <a href="https://medium.com/fantomfoundation" target="_blank" rel="nofollow" title="Corex on Medium">-->
    <!--        <icon data="@/assets/svg/social-media/medium.svg" width="24" height="24"></icon>-->
    <!--      </a>-->
    <!--    </li>-->
    <li>
      <a href="https://www.linkedin.com/company/corexblockchain/" target="_blank" rel="nofollow" title="Corex on Linkedin" class="linkedin">
        <icon data="@/assets/svg/social-media/linkedin.svg" width="24" height="24"></icon>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SocialMediaLinks',
};
</script>

<style lang="scss">
@import 'style';
</style>
